import React, { useEffect, useState, useCallback } from 'react'
import { TextField, Grid, Box, Button,FormHelperText } from "@mui/material"
import { useForm, Controller } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"
import { DriveUsThreeSchema } from '../../Utils/Validations'
import FileValidations from '../FileValidation/FileValidations'
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import 'lightbox2/dist/css/lightbox.min.css';
import lightbox from 'lightbox2';
import $ from 'jquery';
import dayjs from 'dayjs';
const DriveWithUsThree = ({ handleBack, handleComplete, driveUsData, setDriveUsData }) => {
  const {CheckFile,fileError} = FileValidations()
  const [driver_license,setDriver_license] = useState()
  const [driver_license_expiry, setDriver_license_expiry] = React.useState(null);
  const [openImage, setOpenImage] = useState("")
  const [openModal, setOpenModal] = useState(false)
  const { handleSubmit, control, formState: { errors },setValue } = useForm({
    resolver: yupResolver(DriveUsThreeSchema)
  })
  
  const onSubmit = (data) => {
    if(Object.keys(fileError).length===0){
      console.log(data)
      setDriveUsData((prev) => ({ ...prev, driver_license: driver_license, driver_license_expiry:driver_license_expiry, driver_license_number: data.driver_license_number }))
  
      handleComplete()
    }
   
  }
  useEffect(() => {
    lightbox.option({
      'resizeDuration': 200,
      'wrapAround': true,
    });
    setValue("driver_license_expiry", driveUsData.driver_license_expiry || null)
    setValue("driver_license_number", driveUsData.driver_license_number || "")
  }, [driveUsData.driver_license_expiry, driveUsData.driver_license_number, setValue])

  const handleDateChange = useCallback((newValue, onChange) => {
    setDriver_license_expiry(newValue);
    onChange(newValue);
  }, []);

const onChangeFiles = (file, name) => {
  if (!file) {
    console.warn('No file selected');
    return;
  }

  // Use setTimeout to handle file processing asynchronously without blocking the form
  setTimeout(() => {
    try {
      CheckFile(file, name);
      
      if (name === "driver_license") {
        setDriver_license(file)
      }
    } catch (error) {
      console.error('Error handling file selection:', error);
    }
  }, 50); // Small delay for mobile devices
}

const handleOpenModal = (image) => {
  setOpenModal(true)
  setOpenImage(image)
  setTimeout(() => {
    $(document).ready(() => {
      $(`[href="${image}"]`).click();
    });
  }, 0);



}

  return (
    <div>
       {openModal && (
          <a
            href={`${openImage}`}
            data-lightbox="gallery"
            data-title="Image"
            style={{ display: 'none' }}
          >
            Open Image
          </a>
        )}
      <Grid container style={{ justifyContent: "center", marginTop: 20 }} >
        <Grid sm={6} xs={12} sx={{ textAlign: "left", paddingRight: { sm: 1, xs: 0 } }} >
          <Controller
            control={control}
            name="driver_license"
            rules={{ required: true }}
            render={({ field: { onBlur, onChange, value } }) => (
              <>
                <label>Driver License</label>
                <TextField 
                  fullWidth 
                  type="file" 
                  value={value} 
                  onBlur={onBlur}   
                  onChange={(e) => {
                    const file = e.target.files?.[0];
                    if (file) {
                      onChange(e);
                      onChangeFiles(file, "driver_license");
                    }
                  }}
                  error={errors?.driver_license || fileError?.driver_license} 
                  helperText={errors?.driver_license?.message || fileError?.driver_license?.message}
                  inputProps={{
                    accept: "image/*,.pdf,.doc,.docx"
                  }}
                />
                <Box sx={{display:"flex",justifyContent:"space-between",alignItems:"center", mt: 2}} >
                  <Box>
                    <span className='image-detail' >Select any file or image</span><br />
                    <span className='image-detail' >Maximum file size: 50MB</span>
                  </Box>
                  <img src='/driver_forms/assets/images/DRIVERS LICENCE - DMV.png' style={{height:50}} onClick={()=>handleOpenModal("/driver_forms/assets/images/DRIVERS LICENCE - DMV.png")}  />
                </Box>
              </>
            )}
          />
        </Grid>
        <Grid sm={6} xs={12} sx={{ textAlign: "left", paddingLeft: { sm: 1, xs: 0 }, marginTop: { sm: 0, xs: 2 } }}>
        <Controller
            control={control}
            name="driver_license_expiry"
            rules={{ required: true }}
            render={({ field:{onBlur,onChange,value}}) => (
              <>
                 <label>Driver License Expiry</label>
                 <DatePicker
                  sx={{width:"100%"}}
                  className='date-picker'
                  value={value}
                  onChange={(newValue) => handleDateChange(newValue, onChange)}
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      error: !!errors.driver_license_expiry,
                      helperText: errors.driver_license_expiry?.message
                    }
                  }}
                />
                {errors.driver_license_expiry?<FormHelperText component="p" sx={{color:"#d32f2f",px:1.5}} >{errors.driver_license_expiry?.message}</FormHelperText>:null}
              </>
            )}
          />
         
         
        </Grid>
      
        <Grid sm={6} xs={12} sx={{ textAlign: "left", paddingLeft: { sm: 1, xs: 0 }, mt:3 }}>
          <Controller
            control={control}
            name="driver_license_number"
            rules={{ required: true }}
            render={({ field: { onBlur, onChange, value } }) => (
              <>
                <label>Driver License Number</label>
                <TextField fullWidth type="text" value={value} onBlur={onBlur}   onChange={onChange}  error={errors?.driver_license_number} helperText={errors?.driver_license_number?.message} />
               
                
              </>
            )}
          />


        </Grid>
      </Grid>
      <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2,pb:2 }}>
        <Button
          color="inherit"
          // disabled={activeStep === 0}
          onClick={handleBack}
          sx={{ minWidth: "10%",  border: "none", color: "#FFF", bgcolor: "#97c11e", '&:hover': { bgcolor: "#021b38", border: "none" } }}
          variant="contained"
        >
          Back
        </Button>
        <Box sx={{ flex: '1 1 auto' }} />


        <Button color="inherit" variant="contained" sx={{ minWidth: "10%",  border: "none", color: "#FFF", bgcolor: "#97c11e", '&:hover': { bgcolor: "#021b38", border: "none" } }} onClick={handleSubmit(onSubmit)}>


          Next
        </Button>

      </Box>
    </div>
  )
}

export default DriveWithUsThree
